export const passwordValidationRegex = {
  lettersNumbers: /^(?=.*[a-zA-Z])(?=.*\d)/,
  specialCharacter: /[!@#$%^&*(),.?":{}|<>]/,
  sequences:
    /(012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)/i,
  repetitions: /(.)\1{2,}/,
}
